import React from 'react';

import { ReactComponent as ChevronIcon } from 'images/chevron.svg';

import styles from './MoreLink.module.scss';

interface MoreLinkProps {
  onClick: () => void;
  text?: string;
  className?: string;
  showChevron?: boolean;
}

const MoreLink: React.FC<MoreLinkProps> = ({ onClick, text = 'More', className, showChevron = true }) => (
  <button type="button" className={`${styles.moreLink} ${className || ''}`} onClick={onClick}>
    {text}
    {showChevron && <ChevronIcon className={styles.chevron} />}
  </button>
);

export default MoreLink;
